function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAccessTime = function SvgAccessTime(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "eAGM SPOT",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8d3766ov2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2443",
    style: {
      fill: "#e84637"
    },
    d: "M0 0h7.999v8H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2175",
    style: {
      fill: "none"
    },
    d: "M0 0h10v10H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4428"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4427",
    style: {
      clipPath: "url(#8d3766ov2a)"
    },
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 971",
    d: "M4.006 0A4 4 0 1 1 0 3.952 3.995 3.995 0 0 1 4.006 0M2.687 5.569c.013-.012.031-.025.046-.04q.809-.807 1.614-1.618a.2.2 0 0 0 .047-.131V1.207H4v2.4a.2.2 0 0 1-.064.155Q3.2 4.49 2.478 5.22l-.069.074.278.275",
    style: {
      fill: "#e84637"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccessTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/access_time.52323659.svg";
export { ForwardRef as ReactComponent };